import { colorsPalettes, rgba } from "@similarweb/styles";

/**
 * Diagonal striped background used to mark the "compared" period:
 *   - `stripedIndicatorBackground` — small 8px header dot indicator
 *   - `getStripedBackground(color)` — full progress bar fill (overlays diagonal white
 *      stripes onto a solid base color)
 *
 * Both follow the visual convention used in `KeySizingIndicatorsComparisonWidget`.
 */

export const stripedIndicatorBackground = `repeating-linear-gradient(
    -45deg,
    ${colorsPalettes.carbon[200]} 0,
    ${colorsPalettes.carbon[200]} 1px,
    transparent 1px,
    transparent 3px
)`;

export const getStripedBackground = (color: string): string => `${color} repeating-linear-gradient(
    -45deg,
    ${rgba(colorsPalettes.carbon[0], 0.75)} 0,
    ${rgba(colorsPalettes.carbon[0], 0.75)} 2px,
    transparent 2px,
    transparent 4px
)`;
